import script from "./PersonStatusCardComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonStatusCardComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PersonStatusCardComponent.vue?vue&type=style&index=0&id=5cd38028&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cd38028"]])

export default __exports__